import { render, staticRenderFns } from "./SignaturesSpecialist.vue?vue&type=template&id=87dfe0f6&scoped=true"
import script from "./SignaturesSpecialist.vue?vue&type=script&lang=js"
export * from "./SignaturesSpecialist.vue?vue&type=script&lang=js"
import style0 from "./SignaturesSpecialist.vue?vue&type=style&index=0&id=87dfe0f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dfe0f6",
  null
  
)

export default component.exports